<template>
	<Toast/>
	<ConfirmDialog/>
	<div class="p-fluid container-box">
		<div class="p-field field">
			<label for="username">아이디</label>
			<InputText id="username" v-model.trim="user.username" autofocus :class="{'p-invalid': !user.username}" :disabled="true"/>
			<small class="p-error" v-if="!user.username">아이디는 필수항목입니다.</small>
		</div>
		<div class="p-field field">
			<label for="oldPassword">기존 비밀번호</label>
			<Password id="oldPassword" v-model.trim="user.oldPassword" />
		</div>
		<div class="p-field field">
			<label>새 비밀번호 (8 ~ 15자 영문자,숫자,특수문자 조합)</label>
			<Password v-model.trim="user.password1">
				<template #header>
					<h6>Pick a password</h6>
				</template>
				<template #footer="sp">
					{{sp.level}}
					<Divider />
					<p class="p-mt-2">Suggestions</p>
					<ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
						<li>At least one lowercase</li>
						<li>At least one uppercase</li>
						<li>At least one numeric</li>
						<li>Minimum 8 characters</li>
					</ul>
				</template>
			</Password>
		</div>
		<div class="p-field field">
			<label>비밀번호 확인 (새 비밀번호를 다시 입력하세요)</label>
			<Password v-model.trim="user.password2" @change="isValidPassword">
				<template #header>
					<h6>Pick a password</h6>
				</template>
				<template #footer="sp">
					{{sp.level}}
					<Divider />
					<p class="p-mt-2">Suggestions</p>
					<ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
						<li>At least one lowercase</li>
						<li>At least one uppercase</li>
						<li>At least one numeric</li>
						<li>Minimum 8 characters</li>
					</ul>
				</template>
			</Password>
		</div>
		<div class="p-field">
			<Button class="btn-save" label="저장" @click="btnAct('SAVE')"></Button>
		</div>	
	</div>	
</template>

<script>
import { ref, onMounted } from 'vue';
import { useToast } from 'primevue/usetoast';
import UserService from '@/service/cm/UserService';


export default {
	setup() {
		onMounted(() => {
			user.value = JSON.parse(localStorage.getItem("user")); 
			//alert('user.value = ' + JSON.stringify(user.value));
			/*
			userService.getOne(user.value.username).then(data => {
				alert('data = ' + JSON.stringify(data));
				user.value = data;
			});	
			*/
        })
		
        const user = ref({});
		const token = ref();
        const userService = new UserService();
		const toast = useToast();

		const btnAct = (_act) => {
			switch(_act)
			{
				case "SAVE":
					if(!isValidPassword()) {
						return false;
					}

					savePassword();
					break;
				default:
					break;
			}
		}

		// 암호2 입력 시 암호가 동일한 지 확인한다
        const isValidPassword = () => {
			// 기존 비밀번호가 없는 경우
            if(!user.value.oldPassword) {
				toast.add({severity:'warn', summary: '입력 오류', detail:'기존 비밀번호를 입력해주세요', life: 3000});
				return false;
			}

			// 새비밀번호가 없는 경우
            if(!user.value.password1) {
				toast.add({severity:'warn', summary: '입력 오류', detail:'새 비밀번호를 입력해주세요', life: 3000});
				return false;
			}

			// 새비밀번호와 확인용비밀번호가 서로 일치하지 않는 경우
            if(user.value.password1 != user.value.password2) {
				toast.add({severity:'warn', summary: '암호 오류', detail:'새 비밀번호가 일치하지 않습니다', life: 3000});
				user.value.password2 = "";
				return false;
			}

			var id = user.value.username; // 사용자 id
			var pw = user.value.password1; // 새 비밀번호
			var checkNumber = pw.search(/[0-9]/g);
			var checkEnglish = pw.search(/[a-z]/ig);
			var patten = /[#]/;

			if(patten.test(pw)){
				toast.add({severity:'warn', summary: '암호 오류', detail:'특수문자 #은 사용하실수 없습니다.', life: 3000});
				return false;
			}
			if(!/^(?=.*[a-zA-Z])(?=.*[!@$%^*+=-])(?=.*[0-9]).{8,15}$/.test(pw)){            
				toast.add({severity:'warn', summary: '암호 오류', detail:'숫자+영문자+특수문자 조합으로 8 ~ 15자리를 사용해야 합니다.', life: 3000});
				return false;
			}else if(checkNumber <0 || checkEnglish <0){
				toast.add({severity:'warn', summary: '암호 오류', detail:'숫자와 영문자를 혼용하여야 합니다.', life: 3000});
				return false;
			}else if(/(\w)\1\1\1/.test(pw)){
				toast.add({severity:'warn', summary: '암호 오류', detail:'같은 문자를 4번 이상 사용하실 수 없습니다.', life: 3000});
				return false;
			}else if(pw.search(id) > -1){
				toast.add({severity:'warn', summary: '암호 오류', detail:'비밀번호에 아이디가 포함되었습니다.', life: 3000});
				return false;
			}

			// 암호가 서로 일치하면
			user.value.password = user.value.password1;
			return true;
        };

		// 비밀번호를 업데이트한다
		const savePassword = () => {
			userService.updatePassword(user.value.username, user.value.oldPassword, user.value.password1).then(response => {
				//var token = response.data.session.user;
				console.log('response => ', response);
				toast.add({severity:'success', summary: '저장 완료', detail: '암호가 변경되었습니다', life: 3000});
			})
			.catch(error => {
				if (error.response) {
					// The request was made and the server responded with a status code
					toast.add({severity:'error', summary: '저장 오류', detail: error.response.data.message, life: 3000});

				} else if (error.request) {
					// The request was made but no response was received
					// `error.request` is an instance of XMLHttpRequest in the browser and an instance of
					// http.ClientRequest in node.js
					console.log(error.request);
					toast.add({severity:'error', summary: '저장 오류', detail: error.request.data, life: 3000});	
				} else {
					// Something happened in setting up the request that triggered an Error
					console.log('Error', error.message);
					toast.add({severity:'error', summary: '저장 오류', detail: error.message, life: 3000});	
				}
			});
		}

        return {user, token, btnAct, isValidPassword, savePassword}
	}
}
</script>

<style scoped>
.InputText-label{
	text-align:right; 
	margin-top:auto;
	margin-bottom:auto
}
hr{
	margin-bottom:20px;
}
</style>
